import React, { useEffect } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "mapbox-gl-geocoder";
import "mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./mapGIS.css";
// const activeLayers = [];
var savedLayers = [];
let TempActiveLayers = [];
function MapGIS({
  layerName,
  switchIsOn,
  layerOpacity,
  boundingBox,
  buttonOn,
  setButtonOn,
  activeLayers,
  setActiveLayers,
}) {
  const host = process.env.REACT_APP_HOST;

  //useEffect to change the switch when its called and render the layer. When the user clicks on a layer and it gets switched, getWMS source gets called and is used to
  //add or remove the layer

  // useEffect(() => {
  //   if (clearPointClouds) {
  //     // Logic to remove all point clouds from the map
  //     mapRef.current?.removeAllPointClouds(); // example function

  //     // Reset the state so it can be triggered again
  //     setClearPointClouds(false);
  //   }
  // }, [clearPointClouds]);
  useEffect(() => {
    if (
      layerName &&
      switchIsOn &&
      !savedLayers.map((layer) => layer.Name).includes(layerName)
    ) {
      const addLayerSource = (layerName) => {
        const opacity = 1; // Set opacity to 1

        savedLayers.push({
          Name: layerName,
          opacity: 1,
        }); // Add or update the opacity value

        window.map.addSource(`${layerName}-source`, {
          id: `${layerName}-source`,
          type: "raster",
          tiles: [`${host}/getWMS/{bbox-epsg-3857}/${layerName}`],
          tileSize: 512,
        });

        window.map.addLayer({
          id: `${layerName}-layer`,
          type: "raster",
          source: `${layerName}-source`,
          paint: {
            "raster-opacity": 1,
          },
        });
      };
      addLayerSource(layerName);
      TempActiveLayers.push(layerName);
      setActiveLayers([...TempActiveLayers]);
      console.log(TempActiveLayers, "TempActiveLayers");

      if (Array.isArray(boundingBox)) {
        let lngLat = [
          [[boundingBox[0]["@maxx"]], [boundingBox[0]["@maxy"]]],
          [[boundingBox[0]["@minx"]], [boundingBox[0]["@miny"]]],
        ];
        window.map.fitBounds(lngLat, {
          padding: 20,
        });
      } else {
        const lowerCorner = boundingBox["ows:LowerCorner"].split(" ");
        const upperCorner = boundingBox["ows:UpperCorner"].split(" ");

        let lngLat = [
          [upperCorner[0], upperCorner[1]],
          [lowerCorner[0], lowerCorner[1]],
        ];

        window.map.fitBounds(lngLat, {
          padding: 200,
          maxZoom: 16,
        });
      }
    } else if (layerName && layerName !== "removeAll") {
      const removeLayerSource = (layerName) => {
        const layerExists = window.map.getLayer(`${layerName}-layer`);
        const sourceExists = window.map.getSource(`${layerName}-source`);

        if (layerExists && sourceExists) {
          window.map.removeLayer(`${layerName}-layer`);
          window.map.removeSource(`${layerName}-source`);
          console.log("remove layer sto mapgis", layerName);

          savedLayers = savedLayers.filter((layer) => layer.Name !== layerName);
        }
      };
      removeLayerSource(layerName);

      // Remove layerName from activeLayers
      const indexToRemove = TempActiveLayers.indexOf(layerName);
      if (indexToRemove !== -1) {
        TempActiveLayers.splice(indexToRemove, 1);
        setActiveLayers([...TempActiveLayers]);
      }
      savedLayers = savedLayers.filter((layer) => layer.Name !== layerName);
      console.log(TempActiveLayers, "TempActiveLayers");
    } else if ((layerName = "removeAll")) {
      TempActiveLayers = [];
      setActiveLayers([]);
      savedLayers = [];
    }
  }, [layerName, switchIsOn]);
  //Useeffect to fly to a target layer using its bounding box
  useEffect(() => {
    if (boundingBox) {
      if (Array.isArray(boundingBox)) {
        let lngLat = [
          [[boundingBox[0]["@maxx"]], [boundingBox[0]["@maxy"]]],
          [[boundingBox[0]["@minx"]], [boundingBox[0]["@miny"]]],
        ];
        window.map.fitBounds(lngLat, {
          padding: 20,
        });
      } else if (
        boundingBox["ows:LowerCorner"] &&
        boundingBox["ows:UpperCorner"]
      ) {
        const lowerCorner = boundingBox["ows:LowerCorner"].split(" ");
        const upperCorner = boundingBox["ows:UpperCorner"].split(" ");
        console.log(lowerCorner, upperCorner);
        let lngLat = [
          [upperCorner[0], upperCorner[1]],
          [lowerCorner[0], lowerCorner[1]],
        ];

        window.map.fitBounds(lngLat, {
          padding: 200,
          maxZoom: 16,
        });
      }
    }
    return () => {
      setButtonOn(false);
    };
  }, [buttonOn]);
  //The use effect that get called on mount an initializes the map, standard mapbox map in satelite view
  useEffect(() => {
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_KEY;

    var map = new mapboxgl.Map({
      container: "mapGIS", // The ID of the HTML element where the map will be rendered
      style: "mapbox://styles/mapbox/outdoors-v12",
      center: [22.2379578747328, 42.534599159899095], // Initial map center (longitude, latitude)
      zoom: 4, // Initial zoom level
      projection: "globe",
    });
    map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        marker: false,
        mapboxgl: mapboxgl,
        placeholder: "Search",
      })
    );
    map.on("style.load", () => {
      map.setFog({
        color: "rgb(186, 210, 235)", // Lower atmosphere
        "high-color": "rgb(36, 92, 223)", // Upper atmosphere
        "horizon-blend": 0.02, // Atmosphere thickness (default 0.2 at low zooms)
        "space-color": "rgb(83, 95, 141)", // Background color
        "star-intensity": 0.6, // Background star brightness (default 0.35 at low zoooms )
      });
      map.addSource("mapbox-dem", {
        type: "raster-dem",
        url: "mapbox://mapbox.terrain-rgb",
        tileSize: 512,
        maxzoom: 14,
      });
      map.setTerrain({ source: "mapbox-dem", exaggeration: 1 });
    });

    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());

    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
        showUserHeading: true,
      })
    );
    map.addControl(new mapboxgl.FullscreenControl());
    window.map = map;
    return () => {
      map.remove(); // Cleanup the map when the component unmounts
    };
  }, []);

  return <div id="mapGIS" className="mapGIS"></div>;
}

export { MapGIS, savedLayers };
